import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

export enum OpenType{
    popup = 2,
    move = 0,
    tab = 1
}

@Component
export default class HKWorkSystem extends Vue {
    @Prop({type : Array}) quickMenuItems !: gnb.QuickMenuItem[]
    
    onClickedMenu(item:gnb.QuickMenuItem){
        if(item.linkUrl==''){
            (window as any).alertAsync('설정된 링크가 없습니다.')
            return
        }
        this.$emit('fnQuickMenuClick',item)
    }
}